export default "__VITE_ASSET__b9iJ4fC4__"